export type RoadPathKind = 'main' | 'poi-trail';
export type RoadPath = { readonly points: Array<{ x:number; y:number }>; readonly kind: RoadPathKind };
/** Shared world-unit widths: main geometry/presentation is the accepted TH-047 profile. */
export const ROAD_HALF_WIDTH = { main: .85, 'poi-trail': .60 } as const;
export function roadHalfWidth(kind: RoadPathKind): number { return ROAD_HALF_WIDTH[kind]; }
export function roadRibbonLayers(kind: RoadPathKind): readonly (readonly [number,number])[] {
  // Keep the main profile byte-for-byte; trail has proportionally narrower feathering.
  if(kind==='main') return [[.99,.18],[.92,.35],[.85,1]];
  const scale=ROAD_HALF_WIDTH['poi-trail']/ROAD_HALF_WIDTH.main;
  return [[.99*scale,.18],[.92*scale,.35],[.60,1]];
}
